import { RootState } from '..'

const numberOfChanges = (state: RootState) => state.changes.numberOfChanges

export default {
  numberOfChanges,
}
